/*
 * ハロウィン企画: 対象商品の合計が5,000円以上のとき、チミチュリソース50mlを1本だけ自動でカートに入れる
 * - 割引は Shopify の自動割引「ハロウィン企画プレゼント(5,000円以上のお買い上げで)」が担当(0円にする)。
 *   このスクリプトは「カートに入れる/外す」だけ。値段は変えない。
 * - 自動で入れた行には非表示の目印 _gift_auto=1 を付ける(お客様が自分で入れた分と区別するため)
 * - 安全側: 入れたあとにチミチュリが0円でなければ(割引が効かない場合)すぐ外し、そのカートでは二度と入れない
 * - 〜2026-10-31 23:59(日本時間)で自動オフ。オフ後は、残っている自動追加分だけを外す
 * - カートの表示(あと○円でプレゼント/プレゼント中)は、送料無料バーのすぐ下に出す
 */
(function () {
  var CFG = {
    giftVariantId: 47279190507669, // チミチュリソース 50ml
    dogGiftVariantId: 47537775968405, // 牛タン皮ジャーキー お試しサイズ(もう1つのプレゼント)
    thresholdYen: 5000,
    endsAtMs: 1793458799000, // 2026-10-31 23:59:59 JST
    stateKey: 'gift-auto-add-state', // '' | 'added' | 'blocked'
    eligibleProductIds: [
      6269814669461, 6930775834773, 7324979757205, 7632107372693, 7632142532757, 7728031957141, 7797280669845,
      7797291778197, 7797316288661, 7912333410453, 8092489744533, 8169305931925, 8184842551445, 8238946812053,
      8239853306005, 8289065861269, 8301721813141, 8548262707349, 8570989740181, 8589467615381, 8589491601557,
      8589492125845, 8648688140437, 8661136015509, 8664602116245, 8673894760597, 8717928136853, 8792365039765,
      8802306097301, 8845844873365, 8846033453205, 8857122406549, 8878937440405, 8932454957205, 8962543681685,
      9000436072597, 9075017678997, 9126787547285, 9126791282837, 9127487406229, 9180217507989, 9194608165013,
      9195230331029, 9198604386453, 9198607532181, 9198607696021, 9198608810133, 9203168805013, 9203179880597,
      9214121541781, 9215371214997, 9215375376533, 9215375802517, 9215377604757, 9233227186325, 9237281079445,
      9237297660053, 9255037796501, 9260691194005, 9260692308117, 9260705251477, 9260706726037, 9260707512469,
      9346724266133, 9350467911829, 9356139298965, 9385979183253, 15480849399957,
    ],
  };
  var TARGETS = ['#CartDrawer-CartItems', '#main-cart-items .js-contents'];
  var STYLE_ID = 'gift-auto-add-style';
  var eligible = {};
  CFG.eligibleProductIds.forEach(function (id) {
    eligible[id] = true;
  });

  var busy = false;
  var again = false;
  var timer = null;
  var actionTimes = [];

  function routeUrl(name, fallback) {
    return (window.routes && window.routes[name] ? window.routes[name] : fallback) + '.js';
  }

  function isOff() {
    return window.GIFT_AUTO_ADD_OFF === true || Date.now() > CFG.endsAtMs;
  }

  function getState() {
    try {
      return sessionStorage.getItem(CFG.stateKey) || '';
    } catch (e) {
      return '';
    }
  }

  function setState(value) {
    try {
      if (value) sessionStorage.setItem(CFG.stateKey, value);
      else sessionStorage.removeItem(CFG.stateKey);
    } catch (e) {}
  }

  function yen(n) {
    return n.toLocaleString('ja-JP') + '円';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  // カートの中身を、チミチュリ(自動/自分で入れた)・もう1つのプレゼント・対象商品の合計(円)に分ける
  function analyze(cart) {
    var sumCents = 0;
    var ownGiftQty = 0;
    var autoLines = [];
    var dogGift = false;
    cart.items.forEach(function (it) {
      if (it.variant_id === CFG.giftVariantId) {
        if (it.properties && it.properties._gift_auto) autoLines.push(it);
        else ownGiftQty += it.quantity;
        return;
      }
      if (it.variant_id === CFG.dogGiftVariantId) {
        dogGift = true;
        return;
      }
      if (eligible[it.product_id]) sumCents += it.original_line_price;
    });
    // 数量を増やされると、割引で「0円の行」と「有料の行」に分かれる。0円の行を先頭にして、残りは外す
    autoLines.sort(function (x, y) {
      return x.final_line_price - y.final_line_price;
    });
    return { eligibleYen: Math.round(sumCents / 100), ownGiftQty: ownGiftQty, autoLines: autoLines, dogGift: dogGift };
  }

  // 何をするか決める。迷ったら「入れない・外す」
  function decide(a) {
    var plan = { add: false, remove: [], fixQty: null, state: getState() };
    var met = a.eligibleYen >= CFG.thresholdYen;
    var want = !isOff() && met && a.ownGiftQty === 0 && !a.dogGift;
    if (!want) {
      plan.remove = a.autoLines.slice();
      plan.state = '';
      return plan;
    }
    if (plan.state === 'blocked') {
      plan.remove = a.autoLines.slice();
      return plan;
    }
    if (!a.autoLines.length) {
      // 前に自動で入れたのに無い = お客様が自分で外した。入れ直さない
      if (plan.state === 'added') plan.state = 'blocked';
      else {
        plan.add = true;
        plan.state = 'added';
      }
      return plan;
    }
    var first = a.autoLines[0];
    plan.remove = a.autoLines.slice(1);
    if (first.quantity !== 1) {
      plan.fixQty = first;
      plan.state = 'added';
      return plan;
    }
    if (first.final_line_price > 0) {
      // 割引が効いていない(クーポン優先・会社アカウントなど) → 有料のまま入れておかない
      plan.remove = a.autoLines.slice();
      plan.state = 'blocked';
      return plan;
    }
    plan.state = 'added';
    return plan;
  }

  function tooBusy() {
    var now = Date.now();
    actionTimes = actionTimes.filter(function (t) {
      return now - t < 15000;
    });
    return actionTimes.length >= 6;
  }

  function execute(plan) {
    var p = Promise.resolve();
    plan.remove.forEach(function (line) {
      p = p.then(function () {
        return post(routeUrl('cart_change_url', '/cart/change'), { id: line.key, quantity: 0 });
      });
    });
    if (plan.fixQty) {
      p = p.then(function () {
        return post(routeUrl('cart_change_url', '/cart/change'), { id: plan.fixQty.key, quantity: 1 });
      });
    }
    if (plan.add) {
      p = p.then(function () {
        return post(routeUrl('cart_add_url', '/cart/add'), {
          items: [{ id: CFG.giftVariantId, quantity: 1, properties: { _gift_auto: '1' } }],
        });
      });
    }
    return p;
  }

  // カートの表示を、サーバーの最新の状態に入れ替える(Dawnのカート更新と同じ作り)
  function refreshUI() {
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return fetch(cartUrl, { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#main-cart-items .js-contents', '#main-cart-footer .js-contents', '#cart-icon-bubble'].forEach(function (sel) {
          var to = document.querySelector(sel);
          var from = doc.querySelector(sel);
          if (to && from) to.innerHTML = from.innerHTML;
        });
        var drawerTo = document.getElementById('CartDrawer');
        var drawerFrom = doc.getElementById('CartDrawer');
        if (drawerTo && drawerFrom) {
          drawerTo.innerHTML = drawerFrom.innerHTML;
          var wrapper = document.querySelector('cart-drawer');
          var wrapperFrom = doc.querySelector('cart-drawer');
          if (wrapper && wrapperFrom) wrapper.classList.toggle('is-empty', wrapperFrom.classList.contains('is-empty'));
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && wrapper && typeof wrapper.close === 'function') overlay.addEventListener('click', wrapper.close.bind(wrapper));
        }
      })
      .catch(function () {});
  }

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.gift-auto-bar{margin:0 0 1.6rem;padding:1.2rem 1.4rem;border-radius:.8rem;background:#fff4e5;text-align:center}' +
      '.gift-auto-bar__text{margin:0 0 .8rem;font-size:1.4rem;line-height:1.5}' +
      '.gift-auto-bar__text strong{font-size:1.6rem}' +
      '.gift-auto-bar__track{height:.8rem;border-radius:99rem;background:rgba(var(--color-foreground),.12);overflow:hidden}' +
      '.gift-auto-bar__fill{display:block;height:100%;border-radius:99rem;background:#e07b00;transition:width .4s ease}' +
      '.gift-auto-bar--done{background:#eaf5ec}' +
      '.gift-auto-bar--done .gift-auto-bar__text{margin:0}' +
      '.gift-auto-bar__note{margin:.6rem 0 0;font-size:1.1rem;color:rgba(var(--color-foreground),.65)}' +
      '#CartDrawer-CartItems .gift-auto-bar{margin:0 0 .8rem;padding:.8rem 1rem}' +
      '#CartDrawer-CartItems .gift-auto-bar__text{margin:0 0 .5rem;font-size:1.3rem}' +
      '#CartDrawer-CartItems .gift-auto-bar--done .gift-auto-bar__text{margin:0}' +
      '#CartDrawer-CartItems .gift-auto-bar__text strong{font-size:1.5rem}' +
      '#CartDrawer-CartItems .gift-auto-bar__track{height:.6rem}' +
      '#CartDrawer-CartItems .gift-auto-bar__note{margin-top:.4rem;font-size:1rem}';
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  function buildBar(info) {
    var bar = document.createElement('div');
    bar.className = 'gift-auto-bar' + (info.done ? ' gift-auto-bar--done' : '');
    bar.setAttribute('role', 'status');
    if (info.done) {
      bar.innerHTML = '<p class="gift-auto-bar__text"><strong>チミチュリソースをプレゼント中</strong></p>';
    } else {
      bar.innerHTML =
        '<p class="gift-auto-bar__text">あと<strong>' +
        yen(info.remaining) +
        '</strong>でチミチュリソースをプレゼント</p>' +
        '<div class="gift-auto-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
        info.percent +
        '" aria-label="チミチュリソースのプレゼントまで"><span class="gift-auto-bar__fill" style="width:' +
        info.percent +
        '%"></span></div>' +
        '<p class="gift-auto-bar__note">対象商品の合計5,000円(税込)以上で・10/31(土)まで</p>';
    }
    return bar;
  }

  function barInfo(a, cart) {
    if (isOff() || !cart.item_count) return null;
    var giftFree = cart.items.some(function (it) {
      return it.variant_id === CFG.giftVariantId && it.final_line_price === 0;
    });
    if (giftFree) return { done: true };
    if (a.eligibleYen > 0 && a.eligibleYen < CFG.thresholdYen && a.ownGiftQty === 0 && !a.dogGift) {
      return {
        remaining: CFG.thresholdYen - a.eligibleYen,
        percent: Math.max(0, Math.min(100, Math.floor((a.eligibleYen / CFG.thresholdYen) * 100))),
      };
    }
    return null;
  }

  function renderBars(a, cart) {
    addStyle();
    var info = barInfo(a, cart);
    TARGETS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      // 表示の入れ物(中身が空でも常に置く)。Dawnがカートを差し替えると消えるので、見張りにも使う
      var slot = el.querySelector(':scope > .gift-auto-slot');
      var ship = el.querySelector(':scope > .free-shipping-bar');
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'gift-auto-slot';
        if (ship) ship.insertAdjacentElement('afterend', slot);
        else el.insertBefore(slot, el.firstChild);
      } else if (ship && slot.previousElementSibling !== ship) {
        ship.insertAdjacentElement('afterend', slot);
      }
      slot.innerHTML = '';
      if (info) slot.appendChild(buildBar(info));
    });
  }

  function run(depth) {
    depth = depth || 0;
    if (busy) {
      again = true;
      return Promise.resolve();
    }
    busy = true;
    return getCart()
      .then(function (cart) {
        var a = analyze(cart);
        var plan = decide(a);
        var acts = plan.add || plan.remove.length || plan.fixQty;
        if (acts && (depth >= 3 || tooBusy())) {
          // 行き来が続くときは自動追加をやめて、自動分だけ外す
          plan = { add: false, remove: a.autoLines.slice(), fixQty: null, state: 'blocked' };
          acts = plan.remove.length;
        }
        setState(plan.state);
        if (!acts) {
          renderBars(a, cart);
          return false;
        }
        actionTimes.push(Date.now());
        return execute(plan)
          .then(refreshUI)
          .then(function () {
            return true;
          });
      })
      .catch(function () {
        return false;
      })
      .then(function (changed) {
        busy = false;
        if (changed) return run(depth + 1);
        if (again) {
          again = false;
          return run(0);
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      run(0);
    }, 200);
  }

  function containersUnchecked() {
    return TARGETS.some(function (sel) {
      var el = document.querySelector(sel);
      return el && !el.querySelector(':scope > .gift-auto-slot');
    });
  }

  // Dawnのカート更新イベント(数量変更・追加・削除)を見張る。
  // このスクリプトは pubsub.js より先に読み込まれるので、全部読み込まれたあとに繋ぐ
  var hooked = false;
  function hookCartEvents() {
    if (hooked || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    hooked = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }

  function init() {
    window.GiftAutoAdd = { config: CFG, analyze: analyze, decide: decide, run: run };
    run(0);
    new MutationObserver(function () {
      if (containersUnchecked()) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    hookCartEvents();
    document.addEventListener('DOMContentLoaded', hookCartEvents);
    window.addEventListener('load', hookCartEvents);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
